/* tslint:disable */
/* eslint-disable */
/**
 * TOM OPERATIONS SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { CoolingOrderDto } from '../model'
// @ts-ignore
import type { CoolingOrderDtoV2 } from '../model'
// @ts-ignore
import type { CreateReeferTemperatureCommand } from '../model'
// @ts-ignore
import type { UpdateReeferTemperatureCommand } from '../model'
/**
 * ReeferTemperaturesApi - axios parameter creator
 */
export const ReeferTemperaturesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {CreateReeferTemperatureCommand} [createReeferTemperatureCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    create: async (
      createReeferTemperatureCommand?: CreateReeferTemperatureCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/ReeferTemperatures`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createReeferTemperatureCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} [containerNumber]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCoolingOrdersHistoryByContainer: async (
      containerNumber?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/ReeferTemperatures/getCoolingOrdersHistoryByContainer`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (containerNumber !== undefined) {
        localVarQueryParameter['ContainerNumber'] = containerNumber
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} [containerNumber]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCoolingOrdersHistoryByContainerV2: async (
      containerNumber?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/ReeferTemperatures/getCoolingOrdersHistoryByContainerV2`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (containerNumber !== undefined) {
        localVarQueryParameter['ContainerNumber'] = containerNumber
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {boolean} [isForOperator]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInProgressCoolingOrders: async (
      isForOperator?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/ReeferTemperatures/getInProgressCoolingOrders`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (isForOperator !== undefined) {
        localVarQueryParameter['IsForOperator'] = isForOperator
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {boolean} [isForOperator]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInProgressCoolingOrdersV2: async (
      isForOperator?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/ReeferTemperatures/getInProgressCoolingOrdersV2`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (isForOperator !== undefined) {
        localVarQueryParameter['IsForOperator'] = isForOperator
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UpdateReeferTemperatureCommand} [updateReeferTemperatureCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    update: async (
      updateReeferTemperatureCommand?: UpdateReeferTemperatureCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/ReeferTemperatures`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateReeferTemperatureCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ReeferTemperaturesApi - functional programming interface
 */
export const ReeferTemperaturesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ReeferTemperaturesApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {CreateReeferTemperatureCommand} [createReeferTemperatureCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async create(
      createReeferTemperatureCommand?: CreateReeferTemperatureCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.create(
        createReeferTemperatureCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ReeferTemperaturesApi.create']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} [containerNumber]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCoolingOrdersHistoryByContainer(
      containerNumber?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CoolingOrderDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCoolingOrdersHistoryByContainer(
        containerNumber,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ReeferTemperaturesApi.getCoolingOrdersHistoryByContainer']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} [containerNumber]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCoolingOrdersHistoryByContainerV2(
      containerNumber?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CoolingOrderDtoV2>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getCoolingOrdersHistoryByContainerV2(
          containerNumber,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ReeferTemperaturesApi.getCoolingOrdersHistoryByContainerV2']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {boolean} [isForOperator]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInProgressCoolingOrders(
      isForOperator?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CoolingOrderDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getInProgressCoolingOrders(
        isForOperator,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ReeferTemperaturesApi.getInProgressCoolingOrders']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {boolean} [isForOperator]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInProgressCoolingOrdersV2(
      isForOperator?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CoolingOrderDtoV2>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getInProgressCoolingOrdersV2(
        isForOperator,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ReeferTemperaturesApi.getInProgressCoolingOrdersV2']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UpdateReeferTemperatureCommand} [updateReeferTemperatureCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async update(
      updateReeferTemperatureCommand?: UpdateReeferTemperatureCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.update(
        updateReeferTemperatureCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ReeferTemperaturesApi.update']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * ReeferTemperaturesApi - factory interface
 */
export const ReeferTemperaturesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ReeferTemperaturesApiFp(configuration)
  return {
    /**
     *
     * @param {CreateReeferTemperatureCommand} [createReeferTemperatureCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    create(
      createReeferTemperatureCommand?: CreateReeferTemperatureCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<number> {
      return localVarFp
        .create(createReeferTemperatureCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {string} [containerNumber]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCoolingOrdersHistoryByContainer(
      containerNumber?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<CoolingOrderDto>> {
      return localVarFp
        .getCoolingOrdersHistoryByContainer(containerNumber, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {string} [containerNumber]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCoolingOrdersHistoryByContainerV2(
      containerNumber?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<CoolingOrderDtoV2>> {
      return localVarFp
        .getCoolingOrdersHistoryByContainerV2(containerNumber, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {boolean} [isForOperator]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInProgressCoolingOrders(
      isForOperator?: boolean,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<CoolingOrderDto>> {
      return localVarFp
        .getInProgressCoolingOrders(isForOperator, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {boolean} [isForOperator]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInProgressCoolingOrdersV2(
      isForOperator?: boolean,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<CoolingOrderDtoV2>> {
      return localVarFp
        .getInProgressCoolingOrdersV2(isForOperator, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UpdateReeferTemperatureCommand} [updateReeferTemperatureCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    update(
      updateReeferTemperatureCommand?: UpdateReeferTemperatureCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .update(updateReeferTemperatureCommand, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * ReeferTemperaturesApi - object-oriented interface
 */
export class ReeferTemperaturesApi extends BaseAPI {
  /**
   *
   * @param {CreateReeferTemperatureCommand} [createReeferTemperatureCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public create(
    createReeferTemperatureCommand?: CreateReeferTemperatureCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return ReeferTemperaturesApiFp(this.configuration)
      .create(createReeferTemperatureCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} [containerNumber]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getCoolingOrdersHistoryByContainer(
    containerNumber?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return ReeferTemperaturesApiFp(this.configuration)
      .getCoolingOrdersHistoryByContainer(containerNumber, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} [containerNumber]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getCoolingOrdersHistoryByContainerV2(
    containerNumber?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return ReeferTemperaturesApiFp(this.configuration)
      .getCoolingOrdersHistoryByContainerV2(containerNumber, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {boolean} [isForOperator]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getInProgressCoolingOrders(isForOperator?: boolean, options?: RawAxiosRequestConfig) {
    return ReeferTemperaturesApiFp(this.configuration)
      .getInProgressCoolingOrders(isForOperator, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {boolean} [isForOperator]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getInProgressCoolingOrdersV2(isForOperator?: boolean, options?: RawAxiosRequestConfig) {
    return ReeferTemperaturesApiFp(this.configuration)
      .getInProgressCoolingOrdersV2(isForOperator, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UpdateReeferTemperatureCommand} [updateReeferTemperatureCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public update(
    updateReeferTemperatureCommand?: UpdateReeferTemperatureCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return ReeferTemperaturesApiFp(this.configuration)
      .update(updateReeferTemperatureCommand, options)
      .then(request => request(this.axios, this.basePath))
  }
}
